import { connect } from 'react-redux'
import { setTradeIn } from '../../actions'
import RegistrationSearch from './RegistrationSearch'

const mapStateToProps = state => ({
  tradeIn: state.tradeIn,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationSearch)
